// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {
    Input, TextField
} from "@mui/material";

// App Imports


import {changeSubscriber} from "./subscriberSlice";
import {addSubscriber, editSubscriber} from "./SubscriberClient";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import {getAllProducts} from "../Product/ProductClient";
import Stack from "@mui/material/Stack";
import dayjs from "dayjs";
import FormDatePicker from "../../CommonComponents/FormDatePicker";


// Main Function
export default function SubscriberDrawer({contractDataPointDrawerState,contractDataPointDrawerMode}) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************
    const dispatchData = useDispatch();

    const selectorSubscriberId = useSelector((state) => state.subscriberSlc.value.id);
    const selectorSubscriberDrawerState = useSelector((state) => state.subscriberSlc.value.subscriberDrawerState);
    const selectorSubscriberDrawerMode = useSelector((state) => state.subscriberSlc.value.subscriberDrawerMode);

    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    const {register, control, reset, handleSubmit} = useForm();

    // ****************** END REGISTER ****************************


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        console.log("here's my Subscriber data")
        console.log({data})
        console.log("here's my stringify data")
        console.log(JSON.stringify(data, null, 2))
        if(selectorSubscriberDrawerMode==="Add"){
            addSubscriber(data)
                .then(() => {
                    console.log("Subscriber added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeSubscriber({
                    id: null, externalId: null, service: null, source: null,
                    subCount: null, countDate: null, status: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    subscriberGridRefresh: true, subscriberDrawerState: false, subscriberDrawerMode: null}))
            })}
        if(selectorSubscriberDrawerMode==="Clone"){
            addSubscriber(data)
                .then(() => {
                    console.log("Subscriber cloned");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record cloned"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Cloning failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeSubscriber({id: null, externalId: null, service: null, source: null,
                    subCount: null, countDate: null, status: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    subscriberGridRefresh: true, subscriberDrawerState: false, subscriberDrawerMode: null}))
            })}
        if(selectorSubscriberDrawerMode==="Edit"){
            console.log("This is the Subscriber Id I am going to edit")
            console.log(selectorSubscriberId)
            editSubscriber(selectorSubscriberId, data)
                .then(() => {
                    console.log("Subscriber edited")
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() =>{
                setSubmitting(false);
                console.log("trigger refresh")
                dispatchData(changeSubscriber({
                    subscriberGridRefresh: true, subscriberDrawerState: false, subscriberDrawerMode: null}));
            })}
    };

    // ****************** END CRUD ****************************

    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };


    function closeSubscriberDrawer() {
        dispatchData(changeSubscriber({subscriberDrawerState: false }));
    };

    // ****************** END MISC ****************************


    // *********************** BEGIN DROPDOWNS **************************


    const fetchProductsForDropdown = () =>
        getAllProducts()

            .then(data => {
                console.log("Products List")
                console.log(data);
                setProducts(data);

            })
    useEffect(() => {
        console.log("This is for the products dropdown...");
        fetchProductsForDropdown();
    }, []);

// *********************** END DROPDOWNS **************************
    const subscriber = useSelector((state) => state.subscriberSlc.value);

    useEffect(() => {

        reset({
            ...subscriber,
            countDate: subscriber.countDate
                ? dayjs(subscriber.countDate)
                : null,

        });

    }, [subscriber, reset]);

    // ******************* BEGIN AUTOCOMPLETE *********************

    const [dataPointDropdown, setDataPointDropdown] = useState([]);
    const [dataPoints, setDataPoints] = useState([]);
    const [products, setProducts] = useState([]);
    const [selectedDataPoint, setSelectedDataPoint] = useState(null);


    // ****************** BEGIN FORM ****************************

    function subscriberForm(){
        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >
                <Box
                    sx={{ width: 800 , height: 300, pl: 5}}
                    role="presentation"
                >

                    <h2 style={ { paddingLeft: 0,
                        cursor:'pointer'}} onClick={() => closeSubscriberDrawer()}>Subscriber Form</h2>
                    <h4>{selectorSubscriberDrawerMode} Mode</h4>
                    <br/>
                    <br/>
                    <Input
                        style={{ visibility: "hidden" }}
                        {...register('id', { required: true })}
                        id="id" name="id"  label="id" aria-describedby="id_entry"
                        defaultValue=        {Number(useSelector((state) => state.subscriberSlc.value.id))}
                    />
                    <Stack direction="row" spacing={2}>
                    <TextField
                        {...register('externalId', { required: true })}
                        id="externalId"   name="externalId"  label="External ID" aria-describedby="externalId_entry"
                        defaultValue=        {useSelector((state) => state.subscriberSlc.value.externalId)}
                        sx={{ width: 200 }} />
                    <TextField
                        {...register('service', { required: true })}
                        id="service"   name="service"  label="Service" aria-describedby="service_entry"
                        defaultValue=        {useSelector((state) => state.subscriberSlc.value.service)}
                        sx={{ width: 200 }} />
                    <TextField
                        {...register('source', { required: true })}
                        id="source"   name="source"  label="Source" aria-describedby="source_entry"
                        defaultValue=        {useSelector((state) => state.subscriberSlc.value.source)}
                        sx={{ width: 200 }} />
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                    {/*<TextField*/}
                    {/*    {...register('countDate', { required: false })}*/}
                    {/*    id="countDate"   name="countDate"  label="Count Date" aria-describedby="countDate_entry"*/}
                    {/*    defaultValue=        {useSelector((state) => state.subscriberSlc.value.countDate)}*/}
                    {/*    sx={{ width: 200 }} />*/}
                        <FormDatePicker
                            name="countDate"
                            label="Count Date"
                            control={control}
                            width={220}
                            variant = "outlined"
                        />
                        <TextField
                            {...register('subCount', { required: true })}
                            id="subCount"   name="subCount"  label="Subscriber Count" aria-describedby="subCount_entry"
                            defaultValue=        {useSelector((state) => state.subscriberSlc.value.subCount)}
                            sx={{ width: 200 }} />
                        <TextField
                            {...register('status', {required: false})}
                            id="status" name="status" label="Status"
                            aria-describedby="status_entry"
                            defaultValue={useSelector((state) => state.subscriberSlc.value.status)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            disabled={true}
                            TextField{...register('createdBy', {required: false})}
                            id="createdBy" name="createdBy" label="Created By"
                            aria-describedby="createdBy_entry"
                            defaultValue={useSelector((state) => state.subscriberSlc.value.createdBy)}
                            sx={{width: 200}}/>

                        <TextField
                            disabled={true}
                            {...register('createdOn', {required: false})}
                            id="status" name="createdOn" label="Created On"
                            aria-describedby="createdOn_entry"
                            defaultValue={useSelector((state) => state.subscriberSlc.value.createdOn)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedBy', {required: false})}
                            id="lastModifiedBy" name="lastModifiedBy" label="Last Modified By"
                            aria-describedby="lastModifiedBy_entry"
                            defaultValue={useSelector((state) => state.subscriberSlc.value.lastModifiedBy)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedOn', {required: false})}
                            id="lastModifiedOn" name="lastModifiedOn" label="Last Modified On"
                            aria-describedby="lastModifiedOn_entry"
                            defaultValue={useSelector((state) => state.subscriberSlc.value.lastModifiedOn)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <Button
                        type= "submit"
                    >Submit</Button>
                    <Button onClick={() => closeSubscriberDrawer()}>Cancel</Button>
                    <HiddenFields/>
                </Box>
            </form>
        );}

    // ****************** END FORM ****************************


    // ****************** BEGIN HIDDEN FIELDS ****************************

    function HiddenFields() {
        return (
            <div>
            </div>
        )}

    // ****************** END HIDDEN FIELDS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorSubscriberDrawerState}
                onClose={closeSubscriberDrawer}
            >
                {subscriberForm()}

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
